import React from 'react'

function ListHeader({header}) {
    return (
        <div className='part-header'>
            {header}
        </div>
    )
}
export default ListHeader;